import dayjs from "dayjs";
import dayjsGenerateConfig from "rc-picker/lib/generate/dayjs";
import generateDatePicker from "antd/es/date-picker/generatePicker";
import "dayjs/locale/es-mx";
dayjs.locale("es-mx");

const DatePicker =  generateDatePicker<dayjs.Dayjs>(dayjsGenerateConfig);
export default DatePicker;